import {useCallback} from "react";
import {apiEndpoint, useUser} from "@/components/Providers/JWTProvider.tsx";

export const useGetFeeRequestDefaults = (): ((feeId: string) => Promise<Response | undefined>) => {
    const {user} = useUser();

    return useCallback(
        async (feeId: string): Promise<Response | undefined> => {
            if (!user) {
                console.error("missing user");
                return undefined;
            }

            const url = new URL(
                `/v1/myFees/requestDefaults/${encodeURIComponent(feeId)}`,
                apiEndpoint,
            );

            return await user.apiFetch(url.toString(), {
                method: "GET",
            });
        },
        [user],
    );
};
